class ColorVariantPicker {
  constructor(pickerElement) {
    this.picker = pickerElement;
    this.optionsContainer = this.picker.querySelector('.color-variant-picker__options');
    this.prevButton = this.picker.querySelector('.color-variant-picker__arrow--prev');
    this.nextButton = this.picker.querySelector('.color-variant-picker__arrow--next');
    
    if (!this.optionsContainer || !this.prevButton || !this.nextButton) {
      return;
    }

    this.init();
  }

  init() {
    // Check if we have enough options to show arrows
    const options = this.optionsContainer.querySelectorAll('.color-variant-picker__option');
    const hasManyOptions = options.length > 4; // Show arrows if more than 4 options
    
    if (hasManyOptions) {
      this.optionsContainer.setAttribute('data-has-many', 'true');
      this.prevButton.style.display = 'flex';
      this.nextButton.style.display = 'flex';
      this.setupEventListeners();
      this.updateArrowStates();
    } else {
      // Hide arrows if not enough options
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
    }
  }

  setupEventListeners() {
    // Arrow button clicks
    this.prevButton.addEventListener('click', () => this.scroll('prev'));
    this.nextButton.addEventListener('click', () => this.scroll('next'));

    // Update arrow states on scroll
    this.optionsContainer.addEventListener('scroll', () => this.updateArrowStates());

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateArrowStates();
      }, 250);
    });
  }

  scroll(direction) {
    const scrollAmount = this.optionsContainer.offsetWidth * 0.8; // Scroll 80% of container width
    const currentScroll = this.optionsContainer.scrollLeft;
    const maxScroll = this.optionsContainer.scrollWidth - this.optionsContainer.offsetWidth;
    
    let targetScroll;
    if (direction === 'next') {
      targetScroll = Math.min(currentScroll + scrollAmount, maxScroll);
    } else {
      targetScroll = Math.max(currentScroll - scrollAmount, 0);
    }

    this.optionsContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  updateArrowStates() {
    const scrollLeft = this.optionsContainer.scrollLeft;
    const maxScroll = this.optionsContainer.scrollWidth - this.optionsContainer.offsetWidth;
    const threshold = 1; // Small threshold for floating point comparison

    // Update prev button
    if (scrollLeft <= threshold) {
      this.prevButton.disabled = true;
      this.prevButton.setAttribute('aria-disabled', 'true');
    } else {
      this.prevButton.disabled = false;
      this.prevButton.setAttribute('aria-disabled', 'false');
    }

    // Update next button
    if (scrollLeft >= maxScroll - threshold) {
      this.nextButton.disabled = true;
      this.nextButton.setAttribute('aria-disabled', 'true');
    } else {
      this.nextButton.disabled = false;
      this.nextButton.setAttribute('aria-disabled', 'false');
    }
  }
}

// Initialize all color variant pickers on page load
document.addEventListener('DOMContentLoaded', () => {
  const pickers = document.querySelectorAll('.color-variant-picker');
  pickers.forEach(picker => {
    new ColorVariantPicker(picker);
  });
});

// Re-initialize on section load (for Shopify theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const pickers = event.detail.querySelectorAll('.color-variant-picker');
  pickers.forEach(picker => {
    new ColorVariantPicker(picker);
  });
});

